import React from 'react';
import PropTypes from 'prop-types';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { FLAG_NAMES } from '@adsk/acs-admin-ui-components-helpers';
import Content from './component';
import useProjectSettings from '../hooks/useProjectSettings';

const {
  WPLT_FLAGS: { ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS },
} = FLAG_NAMES;

const ContentContainer = ({
  isAdminUser,
  loading: loadingParent,
  showInProductSettings,
  useGetConstructionApis,
}) => {
  const {
    adminAccessProducts,
    dataGetProject,
    loading: loadingProjectSettings,
  } = useProjectSettings(useGetConstructionApis);
  const { loading: loadingAdditionalFieldsFF, value: showAdditionalFields } =
    useAlloyFeatureFlag(ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS);
  const loading =
    loadingProjectSettings ||
    loadingParent ||
    loadingAdditionalFieldsFF ||
    dataGetProject == null;

  return (
    <Content
      adminAccessProducts={adminAccessProducts ?? []}
      data={dataGetProject}
      isAdminUser={isAdminUser}
      loading={loading}
      showAdditionalFields={showAdditionalFields}
      showInProductSettings={showInProductSettings}
    />
  );
};

ContentContainer.propTypes = {
  isAdminUser: PropTypes.bool,
  loading: PropTypes.bool,
  showInProductSettings: PropTypes.bool,
  useGetConstructionApis: PropTypes.bool,
};

ContentContainer.defaultProps = {
  isAdminUser: false,
  loading: true,
  showInProductSettings: false,
};

export default ContentContainer;
